export default __webpack_public_path__ + "static/media/fees.39bb9ac4.gif";